<template>
  <div class="goods_info">
    <div class="shop_top">
      <shop-top
        :subnav_show="false"
        :change_color="true"
        :cart_change="cart_change"
      ></shop-top>
    </div>

    <div class="goods_info_top_mbx width_center_1200">
      <el-breadcrumb separator="/" v-if="!classification">
        <el-breadcrumb-item :to="{ path: '/index.html?v=' + version }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="item in classnameCut(classification).slice(0, 3)" :key="item">
            <a :href="'/goods/params/?keyword=' + item + '&v=' + version">{{item}}</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a>产品详情</a></el-breadcrumb-item>
      </el-breadcrumb>

      <el-breadcrumb separator="/" v-else>
        <el-breadcrumb-item :to="{ path: '/index.html?v=' + version }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a>产品详情</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="goods_info_top width_center_1200">
      <div class="goods_info_top_left">
        <div class="hand_price" v-if="discount_rate && discount_rate > 0 && goodsinfo.showDiscountRate && showPrice == false">
          <div class="money">
            <span>{{ ((rate_price * discount_rate) * curPrice).toFixed(2) }}</span>
          </div>
          <img class="tagg" src="https://www.51bencao.net/imgs/imgs/51bencao/pc/new_price_ico.png"/>
        </div>
        <img v-if="groupsImg" class="tag" :src="filePath + groupsImg" />
        <div class="goods_image_item">
          <pic-zoom :url="filePath + goods_img[chose_img_pos]" :scale="3"></pic-zoom>
        </div>

        <div class="pic_zoom_list">
          <div class="pic_zoom_list_left" @click="pre_img()">
            <i class="el-icon-arrow-left"></i>
          </div>

          <ul>
            <li v-for="(v, k) in goods_img" :key="k" @click="click_silde_img(k)" :class="chose_img_pos == k ? 'border_color' : ''">
              <img v-if="v" :src="filePath + v" alt="" />
            </li>
          </ul>

          <div class="pic_zoom_list_right" @click="next_img()">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="goods_info_top_right">
        <div class="goods_info_title" v-for="v in queryGoods" :key="v.id">
          {{ v.name || "加载中..." }}
          <p>{{ v.company_name || "加载中..." }}</p>
          <div :class="is_collection ? 'goods_info_sc red_color' : 'goods_info_sc'" @click="goods_fav()">
            {{ is_collection ? "已收藏" : "收藏" }}<i class="icon iconfont">&#xe6cf;</i>
          </div>
        </div>
        <!-- 参加活动 -->
        <div class="goods_info_active" v-for="v in queryGoods" :key="v.id">
          <div class="goods_skill tuan_active" v-show="v.nowprice !== null">
            <span><i class="icon iconfont">&#xe8cc;</i></span>
            <span>参加活动</span>
            <span class="span_time">限购：{{ v.max }}</span>
          </div>
        </div>
        <div class="goods_info_group" v-for="v in queryGoods" :key="v.id">
          <div class="goods_info_price" v-if="v.is_ControlSales == false">
            授权查看
          </div>
          <div class="goods_info_price" v-else-if="isLogin == true && v.nowprice !== null">
            <span>活动价：</span>￥{{ v.nowprice }}<span>/{{ v.unit }}</span><span>&nbsp;&nbsp;<del>原价:￥{{ v.price }}</del></span>
          </div>
          <div class="goods_info_price" v-else-if="isLogin == true && v.nowprice == null && v.combo == false">
            <span>批发价：</span>￥{{ v.price }}<span>/{{ v.unit }}</span>
          </div>
          <div class="goods_info_price" v-else-if="isLogin == true && v.nowprice == null && v.combo == true">
            <span>套餐价：</span>￥{{ v.price }}
          </div>
          <div class="goods_info_price" v-else>会员可见</div>

          <div class="goods_info_active" style="height: 20px">
            <dd class="p-icons" v-for="(item, key) in groupsName" :key="key">
              <i v-if="item.id" :class="'goods-icons' + item.id + ' goods-icons J-picon-tips J-picon-fix' ">{{ item.name }}</i>
              <i v-else :class="'goods-icons' + item.id + ' goods-icons J-picon-tips J-picon-fix' ">{{((item.rate * discount_rate)*100).toFixed(0)}}折</i>
            </dd>
            <!-- 新增是否追溯码显示 -->
            <dd class="p-icons" v-if="v.yjm">
              <el-tag type="danger" style="color: #f56c6c;" >追溯码</el-tag>
            </dd>
          </div>
          
          <div class="goods_info_market_price" v-if="v.combo == false">
            <span>生产厂家：</span>
            <div class="overx_goods_info">
            <a :href="'/goods/params/?keyword=' + v.company_name + '&v=' + version">{{ v.company_name }}</a>
              </div>
          </div>

          <div class="goods_info_active">
            <div class="goods_info_cs" v-if="v.approveNo">
              <span>批准文号/生产许可证号:</span
              ><font class="text">{{ v.approveNo }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.batchno">
              <span>批号:</span><font class="text">{{ v.batchno }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.stock">
              <span>库存:</span>
              <font class="text" v-if="v.stock >= 200">充足</font>
              <font class="text" v-else>{{ v.stock }}{{ v.unit }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.spec">
              <span>规格:</span><font class="text">{{ v.spec }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.unit">
              <span>单位:</span><font class="text">{{ v.unit }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.origplace_name">
              <span>产地:</span
              ><font class="text">{{ v.origplace_name }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.med_insurance_code">
              <span>医保码:</span
              ><font class="text">{{ v.med_insurance_code }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.quality_stand">
              <span>质量标准:</span
              ><font class="text">{{ v.quality_stand }}</font>
            </div>
            <div class="goods_info_cs" v-if="v.exp">
              <span>效期:</span><font class="text">{{ v.exp | formatDate}}</font>
            </div>
          </div>
        </div>

        <div class="goods_info_spec" v-show="!this.$isEmpty(queryGoods.chose_attr)">
          <div class="spec_list" v-for="(v, k) in queryGoods.spec_list" :key="k">
            <span>{{ v.name }}：</span>
            <ul>
              <li :class="$isEmpty(val.is_chose) || val.is_chose == false ? '' : 'red'" v-for="(val, key) in v.list" :key="key" @click="attr_click(k, key)">
                {{ val.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="goods_info_active" style="padding: 0 10px">
          <span>服务：</span>
          <font class="text">由科欣网发货 并提供咨询服务。支持: 四川省内单笔订单满500元包邮。</font>
        </div>
        <div class="goods_info_active" style="padding: 0 10px">
          <span>提示：</span>
          <font class="text">1.部分商品包装更换频繁，如货品与图片不完全一致，请以收到的商品实物为准。</font>
          <p class="text">
            2.当发货批号与商品批号不一致时，请以收到的发货批号为准（科欣承诺，发货商品批号不晚于所购买商品批号）。
          </p>
        </div>
        <div class="goods_info_num">
          <div class="goods_info_num_title">购买数量：</div>
          <div class="goods_info_num_jian" @click="change_buy_num(false)">
            <i class="el-icon-minus"></i>
          </div>
          <div class="goods_info_num_input">
            <input
              v-model="buy_num"
              type="text"
              v-enter-number
              @on-change="changenum"
              @change="changenum"
            />
          </div>
          <div class="goods_info_num_jia" @click="change_buy_num(true)">
            <i class="el-icon-plus"></i>
          </div>
          <div class="goods_info_num_stock" v-for="v in queryGoods" :key="v.id">
            &nbsp;&nbsp;库存{{ v.stock }} {{ v.unit }}
          </div>
          <div class="clear"></div>
        </div>
        <div class="goods_info_btn">
          <div
            v-show="goods_info.is_groupbuy == 1"
            class="goods_info_add_groupbuy"
            @click="group_buy()"
          >
            <i class="icon iconfont">&#xe601;</i>选择团购
          </div>
          <div>
            <el-button
              v-if="status != 3"
              type="danger"
              style="
                float: left;
                line-height: 40px;
                margin-right: 20px;
                padding: 0 26px;
                font-size: 16px;
              "
              disabled
              ><i
                class="icon iconfont"
                style="margin-right: 6px; font-size: 20px; font-weight: normal"
                >&#xe602;</i
              >已下架</el-button
            >
            <el-button
              v-else-if="mini_qty > goods_num"
              type="danger"
              style="
                float: left;
                line-height: 40px;
                margin-right: 20px;
                padding: 0 26px;
                font-size: 16px;
              "
              disabled
              ><i
                class="icon iconfont"
                style="margin-right: 6px; font-size: 20px; font-weight: normal"
                >&#xe602;</i
              >库存不足</el-button
            >
            <el-button
              v-else-if="isLogin == false"
              type="primary"
              @click="to_logint()"
              style="
                float: left;
                line-height: 40px;
                margin-right: 20px;
                padding: 0 26px;
                font-size: 16px;
                color: #fff;
                width: 160px;
              "
              >请登录</el-button
            >
            <el-button
              v-else
              type="danger"
              style="
                float: left;
                line-height: 40px;
                margin-right: 20px;
                padding: 0 26px;
                font-size: 16px;
              "
              :disabled="diasabledInput"
              @click="add_cart()"
              ><i
                class="icon iconfont"
                style="margin-right: 6px; font-size: 20px; font-weight: normal"
                >&#xe602;</i
              >加入购物车</el-button
            >
          </div>
          <!-- <vshare></vshare> -->
        </div>
      </div>
      <div class="clear"></div>
    </div>


    <div
      class="goods_info_text width_center_1200"
      style="margin-top: 20px"
      v-if="combinationShow == true && likeList == false && comboList == false && tclist.length > 0">
      <div id="shopRecSuit" class="ETab">
        <div class="tab-main large">
          <ul>
            <li data-tab="trigger" class="J-shopRec-trigger shopRec-trigger current" data-name="套餐商品">
              套餐商品
            </li>
          </ul>
        </div>
        <div class="tab-con clearfix" style="padding: 0">
          <div class="J-shopRec-content shopRec-content taocan" data-tab="item">
            <div class="fl">
              <div class="rolling">
                <el-carousel height="260px" :autoplay="false">
                  <el-carousel-item v-if="tclist.length > 0">
                    <li v-for="item in tclist.slice(0, 5)" :key="item.id">
                      <router-link :to="'/goods/info/' + item.id + '?v=' + version" target="_blank">
                        <p>
                          <span class="total-count">{{ item.qty }}</span>
                          <el-image
                            v-if="item.imgs"
                            :src="filePath + item.imgs"
                            :alt="item.name"
                            :title="item.name"
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </p>
                        <p class="title">{{ item.name }}</p>
                        <p class="ftitle">规格：{{ item.spec }}</p>
                        <p class="mony" v-if="item.is_ControlSales == false">
                          授权查看
                        </p>
                        <p class="mony" v-else-if=" item.price == null && item.nowprice == null " :title="会员可见">
                          会员可见
                        </p>
                        <p class="mony" v-else-if=" item.nowprice == null && item.price != null " >
                          <i>￥</i>{{ item.price }}
                        </p>
                        <p class="mony" v-else><i>￥</i>{{ item.nowprice }}</p>
                      </router-link>
                    </li>
                  </el-carousel-item>

                  <el-carousel-item v-if="tclist.length > 5">
                    <li v-for="item in tclist.slice(5, 10)" :key="item.id">
                      <router-link
                        :to="'/goods/info/' + item.id + '?v=' + version"
                        target="_blank"
                      >
                        <p>
                          <span class="total-count">{{ item.qty }}</span>
                          <el-image
                            :src="filePath + item.imgs"
                            :alt="item.name"
                            :title="item.name"
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </p>
                        <p class="title">{{ item.name }}</p>
                        <p class="ftitle">规格：{{ item.spec }}</p>
                        <p class="mony" v-if="item.is_ControlSales == false">
                          授权查看
                        </p>
                        <p
                          class="mony"
                          v-else-if="
                            item.price == null && item.nowprice == null
                          "
                          :title="会员可见"
                        >
                          会员可见
                        </p>
                        <p
                          class="mony"
                          v-else-if="
                            item.nowprice == null && item.price != null
                          "
                        >
                          <i>￥</i>{{ item.price }}
                        </p>
                        <p class="mony" v-else><i>￥</i>{{ item.nowprice }}</p>
                      </router-link>
                    </li>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div class="fr">
              <div class="infos">
                <div class="p-price" v-if="goodsinfo.price">
                  <span>套餐价</span>
                  <strong class="J_cal_jp">￥{{ goodsinfo.price }}</strong>
                </div>
                <div class="btn">
                  <el-button
                    v-if="status != 3"
                    type="danger"
                    style="
                      float: left;
                      line-height: 40px;
                      margin-right: 20px;
                      padding: 0 26px;
                      font-size: 16px;
                    "
                    disabled
                    ><i
                      class="icon iconfont"
                      style="
                        margin-right: 6px;
                        font-size: 20px;
                        font-weight: normal;
                      "
                      >&#xe602;</i
                    >已下架</el-button
                  >
                  <el-button
                    v-else-if="mini_qty > goods_num"
                    type="danger"
                    style="
                      float: left;
                      line-height: 40px;
                      margin-right: 20px;
                      padding: 0 26px;
                      font-size: 16px;
                    "
                    disabled
                    ><i
                      class="icon iconfont"
                      style="
                        margin-right: 6px;
                        font-size: 20px;
                        font-weight: normal;
                      "
                      >&#xe602;</i
                    >库存不足</el-button
                  >
                  <el-button
                    v-else-if="isLogin == false"
                    type="primary"
                    size="small"
                    @click="to_logint()"
                    style="
                      float: left;
                      line-height: 40px;
                      margin-right: 20px;
                      padding: 0 26px;
                      font-size: 16px;
                      color: #fff;
                    "
                    >请登录</el-button
                  >
                  <el-button
                    v-else
                    type="danger"
                    style="
                      float: left;
                      line-height: 30px;
                      padding: 0 20px;
                      font-size: 16px;
                    "
                    :disabled="diasabledInput"
                    @click="add_cart()"
                    >加入购物车</el-button
                  >
                </div>
                <i class="equal">=</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="goods_info_text width_center_1200"
      style="margin-top: 20px"
      v-else-if="
        combinationShow == false && likeList == false && comboList == true
      "
    >
      <div id="shopRecSuit" class="ETab">
        <div class="tab-main large">
          <ul>
            <li
              data-tab="trigger"
              class="J-shopRec-trigger shopRec-trigger current"
              data-name="套餐买更划算"
            >
              套餐买更划算
            </li>
          </ul>
        </div>
        <div class="tab-con clearfix">
          <div class="J-shopRec-content shopRec-content" data-tab="item">
            <ul class="plist plist-2" id="shop-reco">
              <li class="fore1" v-for="v in combolist.slice(0, 6)" :key="v.id">
                <div class="p-img">
                  <a
                    :href="'/goods/info/' + v.comboId + '?v=' + version"
                    :title="v.name"
                    target="_blank"
                    ><el-image
                      :src="filePath + v.imgs"
                      :alt="v.name"
                      :title="v.name"
                      width="160"
                      height="160"
                      lazy
                    ></el-image
                  ></a>
                </div>
                <div class="p-name">
                  <a
                    :href="'/goods/info/' + v.comboId + '?v=' + version"
                    target="_blank"
                    :title="v.name"
                    >{{ v.name }}</a
                  >
                </div>
                <!-- <div class="spec">{{v.spec}}</div> -->
                <div class="p-price" v-if="v.is_ControlSales == false">
                  <strong>授权查看</strong>
                </div>
                <div
                  class="p-price"
                  v-else-if="v.price == null && v.nowprice == null"
                  :title="会员可见"
                >
                  <strong :class="v.id">会员可见</strong>
                </div>
                <div
                  class="p-price"
                  v-else-if="v.nowprice == null && v.price != null"
                >
                  <strong :class="v.id">￥{{ v.price }}</strong>
                </div>
                <div class="p-price" v-else>
                  <strong :class="v.id">￥{{ v.nowprice }}</strong>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      class="goods_info_text width_center_1200"
      style="margin-top: 20px"
      v-else-if="likeList == true"
    >
      <div id="shopRecSuit" class="ETab">
        <div class="tab-main large">
          <ul>
            <li
              data-tab="trigger"
              class="J-shopRec-trigger shopRec-trigger current"
              data-name="其他规格"
            >
              其他规格
            </li>
          </ul>
        </div>
        <div class="tab-con clearfix">
          <div class="J-shopRec-content shopRec-content" data-tab="item">
            <ul class="plist plist-2" id="shop-reco">
              <li
                class="fore1"
                v-for="v in newproduct_list.slice(0, 6)"
                :key="v.id"
              >
                <div class="p-img">
                  <a
                    :href="'/goods/info/' + v.id + '?v=' + version"
                    :title="v.name"
                    target="_blank"
                  >
                    <el-image
                      v-if="v.img"
                      :src="filePath + v.img"
                      :alt="v.name"
                      :title="v.name"
                      width="160"
                      height="160"
                      lazy
                    ></el-image>
                    <el-image
                      v-else
                      :src="filePath + v.imgFront"
                      :alt="v.name"
                      :title="v.name"
                      width="160"
                      height="160"
                      lazy
                    ></el-image>
                  </a>
                </div>
                <div class="p-name">
                  <a
                    :href="'/goods/info/' + v.id + '?v=' + version"
                    target="_blank"
                    :title="v.name"
                    >{{ v.name }}</a
                  >
                </div>
                <div class="spec">{{ v.spec }}</div>
                <div class="p-price" v-if="v.is_ControlSales == false">
                  <strong>授权查看</strong>
                </div>
                <div
                  class="p-price"
                  v-else-if="
                    isLogin == true && v.price != null && v.nowprice != null
                  "
                >
                  <strong :class="v.id">￥{{ v.nowprice }}</strong>
                </div>
                <div
                  class="p-price"
                  v-else-if="
                    isLogin == true && v.nowprice == null && v.price != null
                  "
                >
                  <strong :class="v.id">￥{{ v.price }}</strong>
                </div>
                <div class="p-price" v-else>
                  <strong :class="v.id"
                    ><strong :class="v.id">会员可见</strong></strong
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="goods_info_text width_center_1200">
      <div class="goods_info_text_left">
        <div class="store_sale">
          <div class="store_info_title">
            <div class="store_info_name">销售排行</div>
          </div>
          <div class="store_sale_list" v-if="sales_sort.length > 0">
            <ul>
              <li v-for="(v, k) in sales_sort" :key="k">
                <router-link :to="'/goods/info/' + v.id + '?v=' + version">
                  <div class="sale_list_num">{{ k + 1 }}</div>
                  <dl>
                    <dt>
                      <el-image :src="filePath + v.img" alt="" lazy></el-image>
                    </dt>
                    <dd class="sale_title">{{ v.name }}</dd>
                    <dd class="spec" style="text-align:left">{{ v.spec }}</dd>
                    <dd v-if="v.is_ControlSales == false" class="sale_price">
                      授权查看
                    </dd>
                    <dd
                      v-else-if="v.price == null && v.nowprice == null"
                      class="sale_price"
                    >
                      会员可见
                    </dd>
                    <dd
                      v-else-if="v.nowprice == null && v.price != null"
                      class="sale_price"
                    >
                      ￥{{ v.price }}
                    </dd>
                    <dd v-else class="sale_price">￥{{ v.nowprice }}</dd>
                  </dl>
                </router-link>
              </li>
            </ul>
          </div>
          <div
            v-else
            style="font-size: 12px; text-align: center; line-height: 40px"
          >
            无任何产品~
          </div>
        </div>
      </div>
      <div class="goods_info_text_right">
        <el-tabs v-model="activeName">
            <el-tab-pane label="商品详情" name="first">
                <el-row :gutter="20" style="padding: 10px; margin: 10px 0 10px 0">
                <div
                    class="after_sale_content"
                    v-if="goods_content"
                    v-html="goods_content"
                ></div>
                <div
                    class="after_sale_content"
                    v-if="describes"
                    v-html="describes"
                ></div>
                </el-row>
            </el-tab-pane>

            <el-tab-pane v-if="qxcertificate != null" label="商品资质" name="qxcertificate">
                <div class="after_sale_content">
                    <el-row :gutter="20" style="padding: 10px" v-if="qxcertificate">
                        <el-col
                        :span="6"
                        v-for="(v, k) in qxcertificate"
                        :key="k"
                        style="margin: 10px 0 10px 0"
                        >
                        <el-popover placement="top-start" trigger="click">
                            <img
                            v-if="v.imgfile"
                            :src="filePath + v.imgfile"
                            style="max-width: 500px; height: auto"
                            />
                            <img
                            v-if="v.imgfile"
                            slot="reference"
                            :src="filePath + v.imgfile"
                            style="
                                width: 220px;
                                min-height: 320px;
                                height: auto;
                                cursor: pointer;
                            "
                            />
                        </el-popover>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>

            <el-tab-pane label="产品实拍" name="third" >
                <div class="after_sale_content">
                    <el-row :gutter="20" style="padding: 10px">
                        <el-col
                        :span="6"
                        v-for="(v, k) in goods_img"
                        :key="k"
                        style="margin: 10px 0 10px 0"
                        >
                        <el-popover placement="top-start" trigger="click">
                            <img
                            v-if="v"
                            :src="filePath + v"
                            style="max-width: 500px; height: auto"
                            />
                            <img
                            v-if="v"
                            slot="reference"
                            :src="filePath + v"
                            style="
                                width: 220px;
                                min-height: 220px;
                                height: auto;
                                cursor: pointer;
                            "
                            />
                        </el-popover>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>

            <el-tab-pane label="科欣承诺" name="fourth">
                <div class="after_sale_content">
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col :span="8" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/营业执照正本20200628.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/营业执照正本20200628.jpg" title="营业执照正本" style="width: 300px; min-height:210px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>

                        <el-col :span="8" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/药品经营许可证20191226.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/药品经营许可证20191226.jpg" title="药品经营许可证" style="width: 300px; min-height:210px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>
        
                        <el-col :span="8" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/gsp证20191226.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/gsp证20191226.jpg" title="gsp证" style="width: 300px; min-height:210px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>
                    </el-row>
                    
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col :span="6" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/20220311医疗器械许可证.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/20220311医疗器械许可证.jpg" title="医疗器械许可证" style="width: 300px; min-height:150px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>

                        <el-col :span="6" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/食品经营许可证正本20200115.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/食品经营许可证正本20200115.jpg" title="食品经营许可证" style="width: 300px; min-height:150px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>
        
                        <el-col :span="6" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/互联网药品信息服务资格证书正本20180328.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/互联网药品信息服务资格证书正本20180328.jpg" title="互联网药品信息服务资格证书" style="width: 300px; min-height:150px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>

                        <el-col :span="6" style="margin:10px 0 10px 0">
                            <el-popover placement="top-start" trigger="click">
                            <img src="/pc/20220322二类医疗器械备案凭证.jpg" style="max-width: 800px;height: auto">
                            <img slot="reference" src="/pc/20220322二类医疗器械备案凭证s.jpg" title="二类医疗器械备案凭证" style="width: 300px; min-height:150px; height: auto; cursor: pointer;">
                            </el-popover>
                        </el-col>

                    </el-row>

                    <div class="shouhou_baozhang">
                        <p class="baozhan_title">服务说明：</p>
                        <p>48小时限时达服务仅限四川省内，且指配送到区县第三方配送点自提；当日上午11：00前提交的订单（以订单出库后完成拣货时间点开始计算），夜里23：00前提交的订单（以订单出库后完成拣货时间点开始计算）。</p>
                        <br/>
                        <p>如遇交通管制、大雨雪、洪涝、冰灾、地震、节假日、周年庆、停电等因素均不在“48小时限时达”服务范围内。</p>
                        <br/>
                        <p class="baozhan_title">药品验收：</p>
                        <p>用户在收到药品时，签字确认前须对药品进行开箱检验，核实药品数量、药品规格是否相符，药品外包装等。如果您验货时发现药品包装破损、药品短缺或错误、药品存在表面质量问题、药品剩余保质期少于6个月（活动、促销、赠送或事先有明确的除外）等其中一项，同时三方货运公司出具相关证明，且证实属实的可拒收；严重问题请拍照上传，便于界定责任并处理。</p>
                        <br/>
                        <p class="baozhan_title">商品退换货政策：</p>
                        <p>用户收到药品起的7天内，符合下列药品退换货要求的，可以退货。拨打科欣医药商城服务热线（028-62068911）进行联系确认后安排第二次发货。</p>
                        <p>（1）由于产品本身存在质量原因，经质量管理部门检验，确属质量问题的；</p>  
                        <p>（2）国家权威管理部门发布公告的产品（如停售、收回等）。</p>  
                        <br/>
                        <p class="baozhan_title">对不具备下列条件的，甲方将不予退换货：</p>
                        <p>（1）在退换货之前未与客户服务中心取得联系； </p> 
                        <p>（2）除非确有质量问题，否则销售的商品包装一经拆封将不予退换；</p>  
                        <p>（3）采购的商品因非正常使用和储藏而出现质量问题的； </p> 
                        <p>（4）退回商品外包装或其他商品附属物不完整或有毁损；</p>  
                        <p>（5）超出质量保证期的商品； </p> 
                        <p>（6）所需退货商品的批号、型号与售出时不符的；</p>  
                        <p>（7） 商品并非由科欣提供的。</p> 
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <shop-foot></shop-foot>
    <ShopMbar></ShopMbar>
  </div>
</template>

<script>
// import VuePhotoZoomPro from 'vue-photo-zoom-pro'
import PicZoom from "@/components/home/public/vue-piczoom.vue"; // 放大镜组件
import ShopTop from "@/components/home/public/head.vue";
import ShopFoot from "@/components/home/public/shop_foot.vue";
// import leftSaleList from "@/components/home/public/left_sale_list" // 左侧销售排行
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"; //右侧固定快捷导航

import { formatDate, format } from "@/utils/date";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";


export default {
  components: {
    PicZoom, // 放大镜
    ShopTop,
    ShopFoot,
    // leftSaleList,// 左侧销售排行
    ShopMbar, //右侧固定快捷导航
    Swiper,
    SwiperSlide,
  },
  props: {},
  data() {
    return {
      activeName: "fourth",
      goods_id: 0, // 商品ID
      promotionId: null, //专享价id
      goods_info: {},
      tclist: [],
      queryGoods: [],
      groupsName: [],
      qxcertificate: [],
      store_info: {},
      buy_num: {}, // 购买数量
      goods_num: {},
      chose_spec: [], // 选择的规格属性
      chose_spec_info: {},
      chose_img_pos: 0,
      goods_img: {},
      goods_images: [],
      comment_list: [], // 评论
      cart_change: 0,
      is_collection: false,
      is_fav: false,
      save_history: true, // 是否需要存储
      //   isSkeleton:false, // false 骨架显示
      comment_image: [],

      // 评论的东西
      total_data: 0, // 总条数
      page_size: 20,
      current_page: 1,
      comment_type: 0,
      bfb: 100,
      star: 5.0,
      comment_num: {
        good: 0,
        secondary: 0,
        bad: 0,
        all: 0,
      },
      diasabledInput: false,
      // 秒杀活动显示
      seckill_intvalobj: null,
      seckill_hour: 0,
      seckill_min: 0,
      seckill_secs: 0,
      newproduct_list: [],
      goods_spuid: null,
      sales_sort: [],
      filePath: null,
      isLogin: false,
      status: null,
      mini_qty: null,
      stock: null,
      goodsinfo: [],
      groupsImg: null,
      exp: null,
      expDate: null, //格式化后日期
      url: null,
      index: 0,
      scale: 3,
      type: "square",
      showType: true,
      changeImgPosition: false,
      taobao: false,
      width: 168,
      height: -1,
      combinationShow: false,
      combo: false,
      comboList: false,
      likeList: false,
      classification: {},
      goods_content: null,
      describes: null,
      combolist: [],
      showPrice:false,
      swiperOption: {
        spaceBetween: 30,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      speciaParam: {
        specialPromotionId: null,
        discountid: null,
      }, //加入购物车参数（活动）
      specialPromotionId: null, //用于判断是否传speciaParam参数
      promotionIds: null,
      isSpecialGoods:false,
      userInfo:[],
      promotion_id:[],
      rate_price:1,
    };
  },
  watch: {},
  filters: {
    formatDate(time) {
      if (time == null || time === "") {
        return "";
      }
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
    //   formatTime(time){
    //     if(time==null||time===''){
    //       return '';
    //     }
    //     let date = new Date(time);
    //     return formatDate(date, 'yyyy-MM-dd')
    //   },
  },
  computed: {},
  methods: {
    //附件路径
    filepath: function () {
      this.$get(this.$api.filepath, { platId: this.$platId }).then((res) => {
        this.filePath = res.data[0].config;
        localStorage.setItem('filePath',res.data[0].config);
      });
    },

    // wx_payCallback:function(){
    //      this.$get(this.$api.wx_payCallback).then(res=>{

    //     });
    // },

    changenum: function (e) {
      if (this.buy_num <= this.mini_qty) {
        this.buy_num = this.mini_qty;
      } else {
        if (this.buy_num < this.goods_num) {
          if (Math.round(this.buy_num / this.goods_num) <= 1) {
            this.buy_num =
              Math.ceil(this.buy_num / this.mini_qty) * this.mini_qty;
          } else {
            this.buy_num =
              (Math.ceil(this.goods_num / this.mini_qty) - 1) * this.mini_qty;
          }
        } else {
          if (this.buy_num >= this.goods_num) {
            if (
              Math.ceil(this.buy_num / this.mini_qty) * this.mini_qty >
              this.goods_num
            ) {
              this.buy_num =
                Math.ceil(this.goods_num / this.mini_qty) * this.mini_qty;
            } else if (
              Math.ceil(this.buy_num / this.mini_qty) * this.mini_qty ==
              this.goods_num
            ) {
              this.buy_num = this.goods_num;
            } else {
              this.buy_num =
                Math.ceil(this.buy_num / this.mini_qty) * this.mini_qty;
            }
          } else {
            if (Math.round(this.buy_num / this.goods_num) < 1) {
              this.buy_num =
                Math.ceil(this.goods_num / this.mini_qty) * this.mini_qty +
                this.mini_qty;
            } else if (Math.round(this.buy_num / this.goods_num) == 1) {
              this.buy_num =
                Math.ceil(this.goods_num / this.mini_qty) * this.mini_qty;
            } else {
              this.buy_num =
                (Math.ceil(this.goods_num / this.mini_qty) - 1) *
                  this.mini_qty +
                this.mini_qty;
            }
          }
        }
      }
    },

    current_change: function (e) {
      this.current_page = e;
      this.get_comment_list();
    },
    get_comment_list: function () {
      this.$post(this.$api.homeGetCommentListByGoods, {
        goods_id: this.goods_id,
        comment_type: this.comment_type,
        page: this.current_page,
      }).then((res) => {
        this.page_size = res.data.comment_list.per_page;
        this.total_data = res.data.comment_list.total;
        this.current_page = res.data.comment_list.current_page;
        this.comment_list = res.data.comment_list.data;
        this.bfb = res.data.bfb;
        this.star = res.data.star;
        this.comment_num = {
          good: res.data.good,
          secondary: res.data.secondary,
          bad: res.data.bad,
          all: res.data.all,
        };
      });
    },
    // 点击缩略图幻灯片图片
    click_silde_img: function (e) {
      this.chose_img_pos = e;
    },
    // pre_img:function(){
    //     if(this.chose_img_pos <= 0){
    //         this.chose_img_pos = this.goods_img.length-1;
    //     }else{
    //         this.chose_img_pos -= 1;
    //     }
    // },
    // next_img:function(){
    //     if(this.chose_img_pos >= this.queryGoods.data.imgsList.length-1){
    //         this.chose_img_pos = 0;
    //     }else{
    //         this.chose_img_pos += 1;
    //     }
    // },

    pre_img: function () {
      if (this.chose_img_pos <= 0) {
        this.chose_img_pos = this.goods_img.length - 1;
      } else {
        this.chose_img_pos -= 1;
      }
    },
    next_img: function () {
      if (this.chose_img_pos >= this.goods_img.length - 1) {
        this.chose_img_pos = 0;
      } else {
        this.chose_img_pos += 1;
      }
    },

    // 购买数量修改
    change_buy_num: function (type) {
      if (type) {
        if (this.buy_num + 1 > this.goods_num) {
          return this.$message.error("库存不足");
        }
        this.buy_num += this.mini_qty;
      } else {
        if (this.buy_num <= this.mini_qty) {
          return this.$message.error("最低购买数量为 " + this.mini_qty);
        }
        this.buy_num -= this.mini_qty;
      }
    },

    // 收藏状态
    is_fav_fun: function () {
      // if(this.$isEmpty(localStorage.getItem('token'))){
      //     return;
      // }
      this.is_collection = this.is_fav;
    },
    goods_fav: function () {
      if (this.isLogin == true) {
        this.$post(this.$api.homeIsFav + this.goods_id).then(() => {
          this.is_fav_fun();
          this.get_goods_info();
        });
      } else {
        this.$message.error("请先登录!");
      }
    },

    // 属性被选择点击
    attr_click: function (e, index) {
      this.queryGoods.spec_list[e]["list"].forEach((res, key) => {
        res.is_chose = false;
        if (key == index) {
          res.is_chose = true;
        }
      });
      this.buy_num = 1;

      // 循环获取选择的规格属性
      let chose_spec = [];
      this.queryGoods.spec_list.forEach((res) => {
        res["list"].forEach((listRes) => {
          if (!this.$isEmpty(listRes.is_chose) && listRes.is_chose == true) {
            chose_spec.push(listRes.name);
          }
        });
      });

      this.chose_spec = chose_spec;

      // 如果选择数量和规格数量一致则表示选择完所有的规格属性
      if (this.chose_spec.length == this.queryGoods.spec_list.length) {
        this.get_spec_attr_data();
      }

      this.$forceUpdate();
    },
    // 根据选择的规格属性去获取数据库存在的规格数据
    get_spec_attr_data: function () {
      this.queryGoods.spec.forEach((res) => {
        let a = 0;
        this.chose_spec.forEach((specRes) => {
          let resInfo = res.spec_name.split(" ");
          if (resInfo.indexOf(specRes) >= 0) {
            a += 1;
          }
        });
        if (a == this.queryGoods.spec_list.length) {
          this.chose_spec_info = res;
          return this.change_goods_info();
        }
      });
    },
    change_goods_info: function () {
      this.queryGoods.price = this.chose_spec_info.price;
      this.queryGoods.goods_market_price =
        this.chose_spec_info.goods_market_price;
      this.goods_num = this.chose_spec_info.goods_num;
    },
    // 如果是多规格产品则将商品价格取第一个规格产品
    is_spec_goods: function () {
      if (!this.$isEmpty(this.queryGoods.chose_attr)) {
        this.queryGoods.goods_price = this.queryGoods.spec[0].goods_price;
        this.queryGoods.goods_market_price =
          this.queryGoods.spec[0].goods_market_price;
        this.goods_num = this.queryGoods.spec[0].goods_num;
      }
    },
    // 立即购买
    buy: function () {
      if (
        !this.$isEmpty(this.queryGoods.chose_attr) &&
        this.chose_spec.length != this.queryGoods.spec_list.length
      ) {
        return this.$message.error("请认真选择属性");
      }
      let str =
        this.queryGoods.id +
        "|" +
        this.queryGoods.store_info.id +
        "|" +
        this.buy_num;
      if (
        !this.$isEmpty(this.chose_spec_info["id"]) &&
        this.chose_spec_info["id"] > 0
      ) {
        str += "|" + this.chose_spec_info["id"];
      }
      this.$router.push("/order/create_order/0/" + str);
    },
    // 拼团购买
    group_buy: function () {
      if (
        !this.$isEmpty(this.queryGoods.chose_attr) &&
        this.chose_spec.length != this.queryGoods.spec_list.length
      ) {
        return this.$message.error("请认真选择属性");
      }
      let str =
        this.queryGoods.id +
        "|" +
        this.queryGoods.store_info.id +
        "|" +
        this.buy_num;
      if (
        !this.$isEmpty(this.chose_spec_info["id"]) &&
        this.chose_spec_info["id"] > 0
      ) {
        str += "|" + this.chose_spec_info["id"];
      }
      this.$router.push("/order/create_order/2/" + str);
    },
    // 加入购物车
    add_cart: function () {
      let that = this;
      let date1 = Math.floor(new Date().getTime() / 1000);
      let date2 = Math.floor(new Date(this.exp).getTime() / 1000);
      this.diasabledInput = true;
      // if(data1 + 31104000 >= date2){
      //         alert('商品效期为' + date2);
      // }
      if (date2 - date1 <= "31104000" && this.exp != null) {
        this.$confirm(
          "该商品为近效期商品, 效期为" + this.expDate + ", 是否继续?",
          "提示",
          {
            // this.$confirm('"该商品为近效期商品"+this.expDate+", 是否继续?"'+this.expDate, '提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            if (this.buy_num == null) {
              return this.$message.error("购买数量不正确");
            } else if (this.buy_num <= this.goods_num) {
              let json = {};
              if (
                //判断商品和列表传过来的活动id是否一致
                this.specialPromotionId == this.speciaParam.specialPromotionId
              ) {
                json = {
                  rows: [
                    {
                      goodsId: this.goods_id,
                      curPrice: this.curPrice,
                      qty: this.buy_num,
                      platId: this.$platId,
                      companyId: this.companyId,
                      operId: null,
                      promoId: null,
                      promoPrice: this.promoPrice,
                    },
                  ],
                  platId: this.$platId,
                  specialParam: [that.speciaParam],
                };
              } else {
                json = {
                  rows: [
                    {
                      goodsId: this.goods_id,
                      curPrice: this.curPrice,
                      qty: this.buy_num,
                      platId: this.$platId,
                      companyId: this.companyId,
                      operId: null,
                      promoId: null,
                      promoPrice: this.promoPrice,
                    },
                  ],
                  platId: this.$platId,
                };
              }
              this.$post(this.$api.homeAddCart, json).then((res) => {
                if (res.code == 200) {
                  if (res.data.indexOf('加入购物车成功') !=-1) {
                    this.get_goods_info();
                    this.cart_change += 1; // 修改购物车数据
                    this.get_cart_count();
                    this.diasabledInput = true;
                    return this.$message.success("加入购物车成功");
                  } else {
                    return this.$message.error(res.data);
                  }
                } else if (res.code == 500) {
                  if (res.message == "请登录") {
                    this.$message.error("请先登录！");
                    return this.$router.push("/user/login");
                  }if(res.code == 401){
                          this.$message.error('请先登录！');
                          localStorage.removeItem('token');
                          localStorage.removeItem('userInfo');        //用户信息
                          localStorage.removeItem('goodsCategory');   //栏目分类
                          localStorage.removeItem('column_list');     //底部菜单
                          localStorage.removeItem('popup_num');       //弹窗广告
                          localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
                          localStorage.removeItem('token');           //清除token
                          localStorage.removeItem('discount_rate');   //清除折扣率
                          return this.$router.push('/user/login');
                     }else {
                    this.diasabledInput = true;
                    return this.$message.error("加入购物车失败");
                  }
                } else {
                  return this.$message.error(res.message);
                }
              });
            } else {
              this.diasabledInput = false;
              return this.$message.error("库存不足");
              //this.diasabledInput = true
            }
            setTimeout(() => {
              this.diasabledInput = false;
            }, 2000);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消",
            });
            setTimeout(() => {
              this.diasabledInput = false;
            }, 2000);
          });
      } else {
        if (this.buy_num == null) {
          return this.$message.error("购买数量不正确");
        } else if (this.buy_num <= this.goods_num) {
            let json = {};
              if (
                //判断商品和列表传过来的活动id是否一致
                this.specialPromotionId == this.speciaParam.specialPromotionId
              ) {
                json = {
                  rows: [
                    {
                      goodsId: this.goods_id,
                      curPrice: this.curPrice,
                      qty: this.buy_num,
                      platId: this.$platId,
                      companyId: this.companyId,
                      operId: null,
                      promoId: null,
                      promoPrice: this.promoPrice,
                    },
                  ],
                  platId: this.$platId,
                  specialParam: [that.speciaParam],
                };
              } else {
                json = {
                  rows: [
                    {
                      goodsId: this.goods_id,
                      curPrice: this.curPrice,
                      qty: this.buy_num,
                      platId: this.$platId,
                      companyId: this.companyId,
                      operId: null,
                      promoId: null,
                      promoPrice: this.promoPrice,
                    },
                  ],
                  platId: this.$platId,
                };
              }
          this.$post(this.$api.homeAddCart, 
              json
          ).then((res) => {
            if (res.code == 200) {
              if (res.data.indexOf('加入购物车成功') !=-1) {
                this.get_goods_info();
                this.cart_change += 1; // 修改购物车数据
                this.diasabledInput = true;
                this.get_cart_count();
                return this.$message.success("加入购物车成功");
              } else {
                return this.$message.error(res.data);
              }
            } else if (res.code == 500) {
              if (res.message == "请登录") {
                this.$message.error("请先登录！");
                return this.$router.push("/user/login");
              } else {
                return this.$message.error("加入购物车失败");
              }
            }if(res.code == 401){
                    this.$message.error('请先登录！');
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');        //用户信息
                    localStorage.removeItem('goodsCategory');   //栏目分类
                    localStorage.removeItem('column_list');     //底部菜单
                    localStorage.removeItem('popup_num');       //弹窗广告
                    localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
                    localStorage.removeItem('token');           //清除token
                    localStorage.removeItem('discount_rate');   //清除折扣率
                    return this.$router.push('/user/login');
                     }else {
              return this.$message.error(res.message);
            }
          });
        } else {
          this.diasabledInput = false;
          return this.$message.error("库存不足");
          //this.diasabledInput = true
        }
        setTimeout(() => {
          this.diasabledInput = false;
        }, 2000);
      }
    },
    // 存储数据记录
    // save_history_fun:function(queryGoods){
    //     this.save_history=false;
    //     let goods_json = localStorage.getItem('shop_goods_historys');
    //     let goods_list = [];

    //     if(!this.$isEmpty(goods_json)){
    //         goods_list = JSON.parse(goods_json);
    //     }

    //     let have_his = false;
    //     if(goods_list.length>0){
    //         goods_list.forEach(res=>{
    //             if(queryGoods.id == res.id){
    //                 res.goods_name = queryGoods.goods_name;
    //                 res.image = queryGoods.goods_master_image;
    //                 res.id = queryGoods.id;
    //                 res.goods_price = queryGoods.goods_price;
    //                 have_his = true;
    //             }
    //         })
    //     }
    //     // console.log(goods_list)

    //     if(!have_his){
    //         goods_list.push({id:queryGoods.id,goods_name:queryGoods.goods_name,goods_price:queryGoods.goods_price,image:queryGoods.goods_master_image});
    //     }

    //     if(goods_list.length>4){
    //         goods_list.splice(0,1);
    //     }

    //     let json_str = JSON.stringify(goods_list);
    //     localStorage.setItem('shop_goods_historys',json_str);

    // },
    // 切换图片
    push_comment_images: function (e) {
      this.comment_image = [];
      e.forEach((res) => {
        this.comment_image.push(res);
      });
    },
    // 查下评论状态
    // change_comment_type:function(e){
    //     this.comment_type = e;
    //     this.get_comment_list();
    // },
    // 活动开始定时任务  秒杀
    seckill_active: function () {
      this.seckill_intvalobj = setInterval(() => {
        let end_time = this.queryGoods.seckill_info.end_time;
        let timestamp = Date.parse(new Date()) / 1000;
        if (end_time > timestamp) {
          let sec2 = end_time - timestamp;
          this.seckill_hour = Math.floor(sec2 / 3600);
          this.seckill_min = Math.floor((sec2 - this.seckill_hour * 3600) / 60);
          this.seckill_secs =
            sec2 - (this.seckill_hour * 60 + this.seckill_min) * 60;
        } else {
          this.queryGoods.is_seckill = 0;
          clearInterval(this.seckill_intvalobj);
        }
      }, 1000);
    },

    classnameCut(name) {
      if (typeof name !== "string") {
        name = name.toString();
      }
      let classname = name.split(",");
      return classname;
    },

    // 获取商品信息
    get_goods_info: function () {
      let json = {};
    //   console.log(this.promotionId);
      if (
        this.promotionId == "" ||
        this.promotionId == undefined ||
        this.promotionId == "null" ||
        this.promotionId == null
      ) {
        json = { goodsId: this.goods_id, platId: this.$platId };
        this.getGoodsList(json);
      } else {
        
        this.$get(this.$api.homeGetUserInfo, { platId: this.$platId }).then(
          (res) => {
            if (res.code == 200) {
              if(res.data && res.data.promotionId){
                let promotionIds = res.data.promotionId;
                let z = promotionIds.split(",");
                let kk = 0;
                for (let i = 0; i < z.length; i++) {
                  // console.log("b:" + z[i]);
                  if (this.promotionId == parseInt(z[i])) {
                    json = {
                      goodsId: this.goods_id,
                      platId: this.$platId,
                      promotionId: this.promotionId,
                    };
                    this.showPrice = true;
                    this.getGoodsList(json);
                    kk++;
                    break;
                  }
                }
                if (kk == 0) {
                    json = { goodsId: this.goods_id, platId: this.$platId };
                    this.getGoodsList(json);
                  
                }
              }else{
                // console.log('456');
                json = { goodsId: this.goods_id, platId: this.$platId };
                this.getGoodsList(json);
              }

            } else {
              json = { goodsId: this.goods_id, platId: this.$platId };
              this.getGoodsList(json);
            }
          }
        );
      }
    },

    //获取商品详情
    getGoodsList: function (json) {

    //   console.log(json);
      this.$get(this.$api.queryGoodsInfoByGoodsId, json).then((res) => {
        if (res.code == 200) {
          if (res.data.list != "") {
            this.queryGoods = res.data.list;
            // this.goodsinfo = res.data.list[0];
            let newList = [];
            res.data.list.map((item, index) => {
              newList.push(Object.assign(item, { showDiscountRate: "true" }));
            });
            this.goodsinfo = newList[0];
            if (this.goodsinfo.groupsName) {
              console.log(this.goodsinfo.groupsName);
              for (var i = 0; i < this.goodsinfo.groupsName.length; i++) {
                if (this.goodsinfo.groupsName[i].name == "秒杀") {
                  this.goodsinfo.showDiscountRate = false;
                } 
                if(this.goodsinfo.groupsName[i].rate && this.goodsinfo.groupsName[i].rate > 0){
                  this.rate_price = this.goodsinfo.groupsName[i].rate;
                }
              }
            }
            this.speciaParam.specialPromotionId = res.data.list[0].promotionId;
            this.speciaParam.discountid = res.data.list[0].discountid;
            this.groupsName = res.data.list[0].groupsName;
            this.qxcertificate = res.data.list[0].qxcertificate;
            this.status = res.data.list[0].status;
            this.is_collection = res.data.list[0].is_collection;
            this.is_fav = res.data.list[0].is_collection;
            if(res.data.list[0].name && res.data.list[0].spec && res.data.list[0].origplace_name){
              document.title = res.data.list[0].name + "("+res.data.list[0].spec+"/"+res.data.list[0].origplace_name+")";
            }
              // "_说明书_作用_副作用_价格_江西御医堂实业有限公司@科欣医药网";
            this.goods_img = res.data.list[0].imgsList;
            this.buy_num = res.data.list[0].mini_qty; // 初始化购买数量
            this.mini_qty = res.data.list[0].mini_qty;
            this.goods_num = res.data.list[0].stock;
            this.combo = res.data.list[0].combo; //是否套餐

            // this.getDiscountRate(); //折扣

            this.exp = res.data.list[0].exp;
            this.expDate = format(res.data.list[0].exp, "YYYY-MM-DD");
            if (res.data.list[0].category_name) {
              this.classification = res.data.list[0].category_name;
            }
            if (res.data.list[0].groupsName) {
              if (res.data.list[0].groupsName[0]) {
                this.groupsImg = res.data.list[0].groupsName[0].groupsImg;
              }
            }

            this.goods_content = res.data.list[0].description;
            this.describes = res.data.list[0].describes;

            // formatDate(res.data.list[0].exp, 'yyyy-MM-dd');
            // console.log(this.exp | formatDate);


            // if(this.promotion_id && this.promotion_id.length > 0){
            //   for(var j = 0; j < this.promotion_id.length; j++){
            //     if(parseInt(this.promotion_id[j]) == res.data.list[0].promotionId){
            //       this.isSpecialGoods = true  //是专享
            //     }else{
            //       this.isSpecialGoods = false
            //     }
            //   }
            // }

            this.chose_spec = [];
            this.chose_spec_info = {};
            this.goodsId = res.data.list[0].id;
            this.goods_spuid = res.data.list[0].spuid;

            //是否套餐
            if (this.combo == true) {
              this.combinationShow = true;
              this.likeList = false;
              if (this.goodsinfo.spuid) {
                this.$get(
                  this.$api.getGoodsDetails + this.goodsinfo.spuid
                ).then((res) => {
                  if (res.code == 200) {
                    if (res.data != null) {
                      this.tclist = res.data;
                    }
                  }
                });
              }
            } else {
              this.$get(this.$api.getComboList + this.goods_id).then((res) => {
                if (res.code == 200) {
                  if (res.data && res.data.length > 0) {
                    this.comboList = true;
                    this.combolist = res.data;
                  } else {
                    //你可能会喜欢
                    this.get_likeproduct_list();
                  }
                }
              });
            }

            //销量排行
            if (res.data.list[0].category_id) {
              this.$get(this.$api.getGoodsBySpuid, {
                spuid: "",
                category_id: res.data.list[0].category_id,
                platId:this.$platId
              }).then((res) => {
                this.sales_sort = res.data;
              });
            } else {
              this.$get(this.$api.getSpecialGoodsById, {
                subjectId: "MjAyMDEwMTNfMTE=",
                platId: this.$platId
              }).then((res) => {
                this.sales_sort = res.data.list[0].indexGoodsParamList;
              });
            }

            if (res.data.list[0].nowprice == null) {
              this.curPrice = res.data.list[0].price; //原价
            } else {
              this.curPrice = res.data.list[0].nowprice; //活动价
            }
            this.companyId = res.data.list[0].company_id;
            this.promoPrice = res.data.list[0].nowprice; //活动价

            if (this.buy_num > this.goods_num) {
              this.diasabledInput = true;
            }

            //最小购买量小于库存，禁止加入购物车
            if (this.mini_qty > this.goods_num) {
              this.diasabledInput = true;
            }

            // 存储游览记录
            // if(this.save_history){
            //     this.save_history_fun(this.queryGoods);
            // }

            // 数据获取成功则开始展示 秒杀活动信息
            if (this.queryGoods.is_seckill == 1) {
              this.seckill_active();
            }
          } else {
            this.$router.push("/");
          }
        } else if (res.code == 401) {
            this.$message.error(res.message);
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');        //用户信息
            localStorage.removeItem('goodsCategory');   //栏目分类
            localStorage.removeItem('column_list');     //底部菜单
            localStorage.removeItem('popup_num');       //弹窗广告
            localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
            localStorage.removeItem('token');           //清除token
            localStorage.removeItem('discount_rate');   //清除折扣率
            // this.get_user_info();
          //this.$router.push('/user/login/');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //当前套餐下商品列表
    // getGoodsDetails:function(){
    //     if(this.goodsinfo.spuid){
    //     this.$get(this.$api.getGoodsDetails + this.goodsinfo.spuid ).then(res=>{
    //         if(res.code == 200){
    //             if(res.data != null){
    //                 this.tclist = res.data;
    //             }

    //         }
    //     });
    //     }
    // },



    //获取用户登录信息
    get_user_info: function () {
      this.$get(this.$api.homeGetUserInfo, { platId: this.$platId }).then((res) => {
          if (res.code == 200) {
            this.isLogin = true;
            this.userInfo = res.data;
            this.userInfo.nowTime =  Date.parse(new Date()) / 1000;
            this.userInfo.isLogin = true;
            localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
            //折扣率
            if(res.data.company && res.data.rate){
                if(res.data.rate != '-1'){
                    localStorage.setItem('discount_rate',res.data.rate);
                }else{
                    localStorage.setItem('discount_rate','');
                }
            }else{
                this.getDiscountRate();
            }
          } else if (res.code == 401) {
            this.isLogin = false;
          } else {
            this.isLogin = false;
          }
        }
      );
    },

    //获取折扣率
    getDiscountRate: function () {
      this.$get(this.$api.getDiscountRate, { platId: this.$platId }).then(
        (res) => {
          if (res.code == 200) {
            if (res.data && res.data.length > 0) {
              this.discount_rate = res.data[0].rate;
              localStorage.setItem('discount_rate',JSON.stringify(res.data[0].rate));
              // console.log(this.discount_rate);
              // console.log(res.data[0].minfee);
            }
          }
        }
      );
    },

    //未登录跳转登录页
    to_logint: function () {
      this.$router.push("/user/login/");
    },

    // 你可能会喜欢
    get_likeproduct_list: function () {
      this.$get(this.$api.getGoodsBySpuid, {
        spuid: this.goods_spuid,
        category_id: "",
        platId:this.$platId
      }).then((res) => {
        if (res.data && res.data.length > 0) {
          var newData = res.data.filter((item) => item.id != this.goodsinfo.id);
          this.newproduct_list = newData;
          if(this.newproduct_list.length > 0){
              this.likeList = true;
          }
        } else {
          this.likeList = false;
          this.newproduct_list = [];
          this.search_goods();
        }
        // this.search_goods();
      });
    },
    // 搜索指定产品
    search_goods: function () {
      this.$get(this.$api.homeSearchGoods, {
        pageNum: 1,
        pageSize: 5,
        sort: 0,
        keyword: this.goodsinfo.company_name,
      }).then((res) => {
        this.newproduct_list = res.data.list;
        // console.log(this.newproduct_list);
      });
    },
    get_cart_count: function () {
      this.$get(this.$api.homeGetCartCount, { platId: this.$platId }).then(
        (res) => {}
      );
    },
  },
  created() {
    this.version = this.$version;
    if(JSON.parse(localStorage.getItem('userInfo'))){
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.isLogin = this.userInfo.isLogin;
    }else{
        this.get_user_info();
    }
    //折扣率
    if(localStorage.getItem('discount_rate')){
        this.discount_rate = localStorage.getItem('discount_rate');
    }
    // this.get_user_info();
    if(localStorage.getItem('filePath')){
        this.filePath = localStorage.getItem('filePath');
    }else{
        this.filepath();
    }
    this.goods_id = this.$route.params.goods_id;

    if(this.$route.query.promotionId != undefined && this.$route.query.promotionId!=null && this.$route.query.promotionId != 'undefined'){
        this.promotionId = this.$route.query.promotionId;
        this.specialPromotionId = this.$route.query.promotionId; //活动id
    }else{
        this.promotionId = null;
        this.specialPromotionId = null; //活动id
    }
   
    if (this.$isEmpty(this.goods_id)) {
      this.$message.error("请检查商品是否存在");
      this.$router.push("/");
    }
    this.get_goods_info();
    this.is_fav_fun();
  },
  beforeRouteUpdate: function (to, from, next) {
    // console.log(to,from)
    this.goods_id = to.params.goods_id;
    if (to.path != from.path) {
      this.get_goods_info();
    }
    // don't forget to call next()
    next();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.goods_info {
  background: #fff;
}
.goods_info_comment_list {
  ul li {
    padding-top: 20px;
    border-bottom: 1px solid #efefef;
    padding-bottom: 30px;
  }
  ul li:after {
    clear: both;
    display: block;
    content: "";
  }
  .comment_avatar {
    width: 40px;
    height: 40px;
    float: left;
    border-radius: 50%;
    background: #efefef;
    margin-right: 15px;
  }
  .comment_nickname {
    font-size: 14px;
    color: #666;
    font-weight: bold;
  }
  .comment_star {
    height: 30px;
    font-size: 14px;
    color: #666;
    line-height: 30px;
    font {
      float: left;
      margin-right: 10px;
    }
    .store_star_in {
      float: left;
      margin-top: 5px;
    }
  }
  .comment_content {
    margin-top: 10px;
    border-top: 1px dashed #efefef;
    padding-top: 10px;
    margin-left: 55px;
    font-size: 14px;
    color: #666;
  }
  .comment_images {
    margin-left: 55px;
    margin-top: 20px;
    .comment_image {
      height: 90px;
      width: 90px;
      border: 1px solid #efefef;
      margin-right: 20px;
      float: left;
    }
  }
}
.comment_list_top {
  margin-bottom: 15px;
  .left_bfb {
    float: left;
    font-size: 48px;
    color: #38a93c;
    line-height: 95px;
    width: 190px;
    text-align: center;
    position: relative;
    border-right: 1px solid #efefef;
    padding-right: 35px;
    span {
      font-size: 14px;
      color: #999;
      position: absolute;
      top: -16px;
      left: 140px;
    }
  }
  .right_comment_list {
    ul li {
      float: left;
      line-height: 48px;
      margin-left: 35px;
      margin-top: 25px;
      color: #666;
      height: 48px;
      padding: 0 40px;
      font-size: 14px;
      background: #efefef;
      border-radius: 3px;
    }
    ul li.red {
      background: #efefef;
      color: #38a93c;
    }
    ul li.red:hover {
      background: #e1e1e1;
      color: #38a93c;
    }
    ul li:hover {
      background: #e1e1e1;
      color: #666;
      -webkit-transition: all 0.2s linear;
      transition: all 0.2s linear;
    }
  }
}
.comment_list_top:after {
  clear: both;
  display: block;
  content: "";
}
.goods_info_sc {
  background: #f6f6f6;
  border-radius: 6px;
  font-size: 14px;
  line-height: 25px;
  color: #666;
  position: absolute;
  top: 0;
  right: 8px;
  padding: 0 10px;
  cursor: pointer;
  i {
    margin-left: 6px;
    font-size: 12px;
  }
}
.goods_info_sc.red_color {
  color: #fff;
  background: #38a93c;
}
.goods_info_sc:hover {
  color: #fff;
  background: #38a93c;
}
.after_sale_content {
  font-size: 14px;
}
.after_sale_content img {
  max-width: 98%;
}
.goods_info_spec {
  margin-top: 20px;
  padding-left: 10px;
  line-height: 20px;
  color: #666;
  .spec_list {
    margin-bottom: 10px;
    span {
      float: left;
      width: 84px;
    }
    ul {
      float: left;
      li {
        float: left;
        color: #666;
        border: 1px solid #e1e1e1;
        border-radius: 2px;
        font-size: 12px;
        padding: 0 8px;
        margin-right: 10px;
      }
      li.red {
        border: 1px solid #38a93c;
        color: #38a93c;
      }
      li:hover {
        border: 1px solid #38a93c;
        color: #38a93c;
      }
    }
  }
  :after {
    content: "";
    display: block;
    clear: both;
  }
}
.goods_info_text {
  // margin-top: 30px;
  .goods_info_text_left {
    width: 234px;
    float: left;
    margin-right: 20px;
  }
  .goods_info_text_right {
    margin-top: 20px;
    width: 946px;
    box-sizing: border-box;
    min-height: 900px;
    // padding:20px;
    float: left;
    border: 1px solid #efefef;
    margin-bottom: 20px;
  }
}
.goods_info_top_right {
  float: left;
  width: 770px;
  font-size: 14px;

  .goods_info_num {
    padding: 10px;
    margin-top: 10px;
    .goods_info_num_title {
      color: #666;
      float: left;
      line-height: 25px;
      margin-right: 15px;
    }
    .goods_info_num_jian {
      border: 1px solid #efefef;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      float: left;
      border-right: none;
      color: #666;
      cursor: pointer;
    }
    .goods_info_num_jia {
      border: 1px solid #efefef;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      float: left;
      border-left: none;
      color: #666;
      cursor: pointer;
    }
    .goods_info_num_stock {
      line-height: 25px;
      color: #999;
    }
    .goods_info_num_input {
      float: left;
    }
    .goods_info_num_input input {
      height: 27px;
      border: 1px solid #efefef;
      outline: none;
      width: 50px;
      text-align: center;
      box-sizing: border-box;
      padding: 0 8px;
      color: #666;
    }
  }
  .goods_info_btn {
    clear: both;
    margin-top: 10px;
  }
  .goods_info_add_cart,
  .goods_info_buy {
    line-height: 40px;
    float: left;
    margin-right: 20px;
    background: #ff5c14;
    // border-radius: 3px;
    color: #fff;
    padding: 0 26px;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    i {
      margin-right: 6px;
      font-size: 20px;
      font-weight: normal;
    }
  }
  .goods_info_buy {
    background: #df3033;
    i {
      font-size: 12px;
    }
  }

  .goods_info_add_groupbuy {
    line-height: 40px;
    float: left;
    margin-right: 20px;
    background: #67c23a;
    border-radius: 3px;
    color: #fff;
    padding: 0 15px;
    i {
      margin-right: 6px;
    }
  }

  .goods_info_title {
    position: relative;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 15px;
    color: #666;
    font-weight: 700;
    p {
      color: #666;
      line-height: 25px;
      font-weight: normal;
      font-size: 12px;
    }
  }
  .goods_info_group {
    // position: relative;
    box-sizing: border-box;
    padding: 20px;
    // padding-bottom: 90px;
    height: 180px;
    background: url("/pc/summary-bg.jpg");
  }
  .goods_info_price {
    color: #e4393c;
    font-size: 28px;
    line-height: 28px;
    span {
      line-height: 28px;
      color: #999;
      font-size: 14px;
    }
  }
  .goods_info_market_price {
    margin-top: 10px;
    span {
      color: #999;
    }
    .overx_goods_info {
      // text-decoration: line-through;
      display: inline-block;
    }
  }
  .goods_info_sale_num {
    position: absolute;
    font-size: 12px;
    right: 16px;
    color: #333;
    top: 30px;
    font {
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  .goods_info_phone_read {
    position: absolute;
    right: 24px;
    font-size: 12px;
    color: #999;
    top: 140px;
    i {
      margin-left: 10px;
      color: #666;
    }
  }

  .goods_info_active {
    // margin-top: 20px;
    // height: 30px;
    // line-height: 30px;
    .goods_info_cs {
      // width: 33%;
      margin-right: 20px;
      float: left;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .goods_info_cs:first-child {
      margin-left: 0px;
    }
    span {
      color: #999;
    }
    font {
      background: #ff6590;
      color: #fff;
      line-height: 34px;
      padding: 4px 8px;
      margin-right: 10px;
      border-radius: 3px;
    }
    font.noy {
      background: #67c23a;
    }
    font.noz {
      background: #999;
    }
    font.text {
      color: #999;
      font-size: 12px;
      background: none;
    }
    p.text {
      color: #999;
      font-size: 12px;
      background: none;
      margin-left: 45px;
    }
    .goods_skill {
      // margin-bottom: 10px;
      background: #fef0f0;
      border: 1px solid #fde2e2;
      font-size: 14px;
      span {
        color: #f56c6c;
        line-height: 40px;
        i {
          font-size: 18px;
          line-height: 40px;
          margin-right: 20px;
          margin-left: 20px;
          float: left;
        }
      }
      span.span_time {
        float: right;
        margin-right: 30px;
      }
    }
    .tuan_active {
      background: #f0f9eb;
      border: 1px solid #e1f3d8;
      span {
        color: #67c23a;
      }
    }
  }
}
.goods_info_top_mbx {
  margin: 30px auto;
}
.goods_info_top_left {
  width: 402px;
  border: 1px solid #efefef;
  margin-right: 28px;
  float: left;
  box-sizing: border-box;
  .goods_image_item {
    width: 400px;
    height: 400px;
    display: block;
    border-bottom: 1px solid #efefef;
  }
  .pic_zoom_list {
    ul li {
      float: left;
      margin: 10px 10px 10px 0;
      border: 1px solid #efefef;
      cursor: pointer;
      img {
        width: 60px;
        height: 60px;
      }
    }
    ul li:hover {
      border-color: #38a93c;
    }
    ul li:last-child {
      margin-right: 0;
    }
    ul li.border_color {
      border-color: #38a93c;
    }
    .pic_zoom_list_left {
      font-size: 24px;
      float: left;
      line-height: 80px;
      color: #666;
      margin-right: 10px;
      margin-left: 10px;
      cursor: pointer;
      :hover {
        color: #38a93c;
      }
    }
    .pic_zoom_list_right {
      font-size: 24px;
      float: right;
      line-height: 80px;
      color: #666;
      margin-right: 10px;
      margin-left: 10px;
      cursor: pointer;
      :hover {
        color: #38a93c;
      }
    }
  }
}
.is-active {
  color: #fff !important;
}
.plist-2 .el-image {
  width: 160px;
  height: 160px;
  //margin: 25px 14px 25px 14px;
  transition: 0.2s all linear;
  -moz-transition: 0.2s all linear;
  -webkit-transition: 0.2s all linear;
  -o-transition: 0.2s all linear;
}
</style>


<style lang="scss" scoped>
.store_sale {
  border: 1px solid #efefef;
  margin-top: 20px;
  .store_info_title {
    background: #fafafa;
    padding: 5px 10px;
    border-bottom: 1px solid #efefef;
    .store_info_name {
      line-height: 24px;
      font-size: 14px;
      width: 150px;
      height: 24px;
      overflow: hidden;
    }
  }
  .store_sale_list {
    ul li {
      border-bottom: 1px solid #efefef;
      position: relative;
      .sale_list_num {
        width: 20px;
        height: 20px;
        position: absolute;
        background: #38a93c;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        // top:-16px;
        left: 10px;
        z-index: 9;
      }
      dl {
        margin: 20px 10px;
        dt {
          width: 80px;
          height: 80px;
          float: left;
          margin-right: 10px;
          img {
            width: 80px;
            height: 80px;
          }
        }
        dd {
          font-size: 14px;
          color: #666;
        }
        dd.sale_price {
          margin-top: 10px;
          color: #e4393c;
        }
        dd.sale_title {
          height: 23px;
          overflow: hidden;
          padding-top: 5px;
          line-height: 22px;
        }
      }
    }
    ul li dl:after {
      content: "";
      clear: both;
      display: block;
    }
    ul li:last-child {
      border-bottom: none;
    }
    ul li:nth-child(4),
    ul li:nth-child(5),
    ul li:nth-child(6) {
      .sale_list_num {
        background: #333;
      }
    }
  }
}
.store_sale:after {
  content: "";
  clear: both;
  display: block;
}
.store_sale_list .el-image {
  width: 80px;
  height: 80px;
  //margin: 25px 14px 25px 14px;
  transition: 0.2s all linear;
  -moz-transition: 0.2s all linear;
  -webkit-transition: 0.2s all linear;
  -o-transition: 0.2s all linear;
}
.el-tabs__item:last-child {
  padding-right: 20px !important;
}
.kexin_zhengshu,
.kexin_zhengshu img {
  margin: 0 auto;
  text-align: center;
}
.shouhou_baozhang {
  padding: 10px;
  text-indent: 28px;
}
.shouhou_baozhang p {
  line-height: 20px;
}
.baozhan_title {
  text-indent: 0;
  font-weight: 600;
  color: #ff0000;
}
#tab-first {
  padding-left: 20px;
}
.spec {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.img-container{
  height: 400px;
}

.img-container img {
  width: 400px;
  /*height: 400px;*/
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}
.el-tabs__item {
  padding: 0px !important;
}
.origin-img {
  height: 400px !important;
  width: 400px !important;
  position: absolute;
}
.rolling li .el-image {
  width: 160px;
  height: 160px;
  margin: 10px;
  transition: 0.2s all linear;
  -moz-transition: 0.2s all linear;
  /* Firefox 4 */
  -webkit-transition: 0.2s all linear;
  /* Safari å’Œ Chrome */
  -o-transition: 0.2s all linear;
  /* Opera */
}
.rolling li:hover .el-image {
  transform: scale(1.1);
}
.shopRec-content .el-image {
  width: 160px;
  height: 160px;
  margin: 10px;
  transition: 0.2s all linear;
  -moz-transition: 0.2s all linear;
  /* Firefox 4 */
  -webkit-transition: 0.2s all linear;
  /* Safari å’Œ Chrome */
  -o-transition: 0.2s all linear;
  /* Opera */
}
.shopRec-content li:hover .el-image {
  transform: scale(1.1);
}
.el-carousel__indicators {
  display: none;
}
.tag {
  /* position: absolute;
  text-align: right;
  float: right;
  width: 400px;
  height: 400px;
  z-index: 9; */
  position: absolute;
  text-align: right;
  float: right;
  z-index: 9;
  /* margin-left: 317px; */
}
/* .hand_price {
  float: right;
  width: 400px;
  height: 400px;
} */

.hand_price .text {
  position: absolute;
  text-align: left;
  float: right;
  font-size: 20px;
  margin-left: 10px;
  margin-top: 330px;
  height: 26px;
  line-height: 26px;
  z-index: 11;
}
.hand_price .money {
  position: absolute;
  text-align: center;
  font-size: 18px;
  margin-top: 360px;
  height: 49px;
  line-height: 49px;
  margin-left: 10px;
  font-weight: bold;
  z-index: 15;
  color: #fff;
  /* background-color: #f7e5c3;
    background-image: linear-gradient(120deg, #f7e5c3 0%, #fdc680 100%);
    border-radius: 0 10px 10px 0; */
  width: 150px;
  padding-left: 10px;
}
.hand_price .money span {
  /* position: absolute; */
  text-align: center;
  font-size: 30px;
  height: 49px;
  line-height: 49px;
  width: 150px;
  margin-right: 10px;
  /* background-color: #f7e5c3; */
  /* background-image: linear-gradient(60deg, #f7e5c3 0%, #fdc680 33%);
    border-radius: 0 10px 10px 0; */
  z-index: 12;
}
.hand_price img {
  position: absolute;
  text-align: right;
  float: right;
  width: 164px;
  height: 60px;
  margin-top: 340px;
  z-index: 13;
}
.img-zoomer,
.img-out-show {
  z-index: 9999 !important;
}
</style>